import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { resendInvoice as resendInvoiceApi } from "../../../../api/orders/orders";
import { Link } from "react-router-dom";
import { NOTIFICATION_ORDER_ACTIONS } from '../../../../config/notifications';
import { ACL, ORDER_STATUSES } from '../../../../config/constants';
import { store } from '../../../../store/store';
import { hideNotification } from '../../../../store/actions/notification';

function ResendInvoice(props) {
  const [showResendInvoiceModal, setShowResendInvoiceModal] = useState(false);
  const {index, order, showIcon} = props;

  if (
    ! ACL.CLIENT.ORDERS.SEND_EMAIL.hasAccess() ||
    order.status === ORDER_STATUSES.CANCELLED_BY_USER ||
    order.status === ORDER_STATUSES.CANCELLED_BY_ADMIN ||
    order.status === ORDER_STATUSES.REFUND_ERROR
  ) {
    return null;
  }

  const resendInvoice = () => {
    resendInvoiceApi({
      orderId: order.id,
      notificationId: NOTIFICATION_ORDER_ACTIONS,
    }).then(() => {
      setShowResendInvoiceModal( false );
    });
  };

  return (<Fragment>
      {!showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`resend-invoice-icon-${index}`}
            onClick={(e) => {
              e.target.blur();
              store.dispatch(hideNotification());
              setShowResendInvoiceModal(true)
            }}
          >
            <FormattedMessage
              id="components.pages.orders.table.actionButtons.resend_invoice"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`resend-invoice-icon-${index}`}
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
          >
            <FormattedMessage
              id="components.pages.orders.table.actionButtons.resend_invoice"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`resend-invoice-icon-` + props.index}
            onClick={(e) => {
              e.target.blur();
              setShowResendInvoiceModal(true)
            }}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faEnvelope}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`resend-invoice-icon-${props.index}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            <FormattedMessage
              id="components.pages.orders.table.actionButtons.resend_invoice"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <ConfirmationModal
        showModal={showResendInvoiceModal}
        closeModal={() => setShowResendInvoiceModal(false)}
        confirmationYes={resendInvoice}
        messageId="components.layout.confirmation.body.resend_invoice"
      />
    </Fragment>
  );
}

export { ResendInvoice };
